/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloneIntegrationVersionRequest
 */
export interface CloneIntegrationVersionRequest {
    /**
     * 
     * @type {string}
     * @memberof CloneIntegrationVersionRequest
     */
    newVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof CloneIntegrationVersionRequest
     */
    releaseNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof CloneIntegrationVersionRequest
     */
    configurationSchema?: string;
    /**
     * 
     * @type {string}
     * @memberof CloneIntegrationVersionRequest
     */
    availableFunctions?: string;
    /**
     * 
     * @type {string}
     * @memberof CloneIntegrationVersionRequest
     */
    defaultMappings?: string;
    /**
     * 
     * @type {string}
     * @memberof CloneIntegrationVersionRequest
     */
    defaultTriggerRules?: string;
    /**
     * 
     * @type {string}
     * @memberof CloneIntegrationVersionRequest
     */
    sourceCode?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CloneIntegrationVersionRequest
     */
    packageInfo?: { [key: string]: any; };
}

/**
 * Check if a given object implements the CloneIntegrationVersionRequest interface.
 */
export function instanceOfCloneIntegrationVersionRequest(value: object): value is CloneIntegrationVersionRequest {
    return true;
}

export function CloneIntegrationVersionRequestFromJSON(json: any): CloneIntegrationVersionRequest {
    return CloneIntegrationVersionRequestFromJSONTyped(json, false);
}

export function CloneIntegrationVersionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloneIntegrationVersionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newVersion': json['newVersion'] == null ? undefined : json['newVersion'],
        'releaseNotes': json['releaseNotes'] == null ? undefined : json['releaseNotes'],
        'configurationSchema': json['configurationSchema'] == null ? undefined : json['configurationSchema'],
        'availableFunctions': json['availableFunctions'] == null ? undefined : json['availableFunctions'],
        'defaultMappings': json['defaultMappings'] == null ? undefined : json['defaultMappings'],
        'defaultTriggerRules': json['defaultTriggerRules'] == null ? undefined : json['defaultTriggerRules'],
        'sourceCode': json['sourceCode'] == null ? undefined : json['sourceCode'],
        'packageInfo': json['packageInfo'] == null ? undefined : json['packageInfo'],
    };
}

export function CloneIntegrationVersionRequestToJSON(json: any): CloneIntegrationVersionRequest {
    return CloneIntegrationVersionRequestToJSONTyped(json, false);
}

export function CloneIntegrationVersionRequestToJSONTyped(value?: CloneIntegrationVersionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newVersion': value['newVersion'],
        'releaseNotes': value['releaseNotes'],
        'configurationSchema': value['configurationSchema'],
        'availableFunctions': value['availableFunctions'],
        'defaultMappings': value['defaultMappings'],
        'defaultTriggerRules': value['defaultTriggerRules'],
        'sourceCode': value['sourceCode'],
        'packageInfo': value['packageInfo'],
    };
}

